module.exports = __webpack_public_path__ + "img/autosense-compatibility-check.d02ead13.png";